import {
  EasyTeamTimesheetAddedEventDetails,
  EasyTeamTimesheetEvent,
  EasyTeamTimesheetEventType,
  EasyTeamTimesheetsDeletedEventDetails,
  EasyTeamTimesheetsEditedEventDetails,
} from "types/easyTeam/EasyTeamTimesheetEvent";

export const isEasyTeamTimesheetAddEvent = (
  data: EasyTeamTimesheetEvent,
): data is EasyTeamTimesheetAddedEventDetails => {
  return data.event_type === EasyTeamTimesheetEventType.ON_TIMESHEET_ADD;
};

export const isEasyTeamTimesheetsEditEvent = (
  data: EasyTeamTimesheetEvent,
): data is EasyTeamTimesheetsEditedEventDetails => {
  return data.event_type === EasyTeamTimesheetEventType.ON_TIMESHEETS_EDIT;
};

export const isEasyTeamTimesheetsDeleteEvent = (
  data: EasyTeamTimesheetEvent,
): data is EasyTeamTimesheetsDeletedEventDetails => {
  return data.event_type === EasyTeamTimesheetEventType.ON_TIMESHEETS_DELETE;
};
